/**
 * Ukrainian, core bundle — the surfaces reachable from the MAIN CHUNK: the
 * public board, the landing page, the staff gate, the sentences behind every
 * `{
 error }` code, and the renderers for labels that live in `shared/`.
 *
 * This file is the SCHEMA. `Messages` is `typeof core & typeof staff` taken
 * from the two Ukrainian dictionaries, and English is declared `satisfies` a
 * mirror of them — so a key added here and forgotten there does not compile.
 *
 * It is also the only dictionary statically imported into the main chunk, and
 * therefore the fallback table: a key missing from the active locale renders
 * its Ukrainian rather than its key.
 *
 * `,
 * rows are listed in `src/i18n/GLOSSARY.md` for the owner to settle; nothing
 * about the code depends on the answer.
 */

export const core = {
  "fan.finalDay": "В останній день турніру тут почнеться голосування та з’явиться трійка лідерів.",
  "fan.stageWaiting": "Герой ще не визначений",
  "fan.noVotesClosed": "Голосування завершилося без голосів.",
  "fan.noWinner": "Цього разу без переможця",
  "fan.noVotes": "Лідери з’являться після перших голосів. Обирай будь-кого зі складів команд.",
  "fan.firstVote": "Перша зірка чекає на твій голос",
  "fan.support": "Підтримати",
  "fan.rank": "Місце {rank}",
  "fan.topTied": {
    one: "Ще {count} гравець ділить останнє показане місце.",
    few: "Ще {count} гравці ділять останнє показане місце.",
    many: "Ще {count} гравців ділять останнє показане місце.",
    other: "Ще {count} гравця ділять останнє показане місце.",
  },
  "fan.topShare":
    "100% на шкалі = голоси за показаних лідерів. Голоси за інших гравців теж враховуються.",
  "fan.top": "Підсумкова трійка",
  "fan.topLive": "Лідери зараз",
  "fan.oneVote": "Один голос за будь-кого зі складів команд. До закриття можна передумати.",
  "fan.allResults": "Усі результати",
  "fan.changePlayer": "Змінити вибір",
  "fan.choosePlayer": "Обрати гравця",
  "fan.playerShort": "Гравець турніру",
  "fan.award": "Вибір вболівальників",
  "fan.tagline": "Обирай героя. Вгадуй переможців.",
  "fan.title": "Фан-зона",
  "fan.player": "Гравець турніру за версією вболівальників",
  "fan.playerNote":
    "Хто змусив трибуни вибухнути? Віддай голос за того, хто зробив цей турнір особливим.",
  "fan.opens": "Голосування відкриється {day} о 00:00 ({zone}).",
  "fan.open": "Голосування відкрите до кінця сьогоднішнього дня ({zone}).",
  "fan.closed": "Голосування завершено",
  "fan.unavailable": "Голосування стане доступним після налаштування дат і часового поясу турніру.",
  "fan.yourPlayer": "Ваш вибір: {name}",
  "fan.votes": "Голосів: {count}",
  "fan.picks": "Прогнозів: {count}",
  "fan.search": "Знайти гравця або команду",
  "fan.vote": "Голосувати",
  "fan.voteFor": "Підтримати: {name}",
  "fan.selected": "Обрано",
  "fan.noPlayersFound": "За цим запитом гравців не знайдено.",
  "fan.noPlayers": "Гравці з’являться після заповнення складів команд.",
  "fan.more": "Показати ще",
  "fan.predictions": "Прогнози на матчі",
  "fan.predictionsNote":
    "На кого ставиш? Обирай переможців та перевіряй свою інтуїцію. Граємо без грошей.",
  "fan.whoWins": "Хто переможе?",
  "fan.matchOpen": "До старту можна передумати.",
  "fan.matchClosed": "Прогнози на цей матч закриті.",
  "fan.correct": "Ваш прогноз зіграв!",
  "fan.incorrect": "Цього разу перемогла інша команда.",
  "fan.draw": "Нічия. Переможця немає.",
  "fan.filter": "Фільтр прогнозів",
  "fan.filter.open": "Відкриті",
  "fan.filter.all": "Усі матчі",
  "fan.filter.mine": "Мої прогнози",
  "fan.noMatches": "У цьому списку ще немає матчів із підтвердженими командами.",
  "fan.retry": "Оновити",
  "fan.saving": "Зберігаємо вибір…",
  "fan.saved": "Ваш вибір збережено",
  "error.fan-closed": "Це голосування вже закрите або ще не відкрилося. Оновіть сторінку.",
  "error.fan-choice": "Цей варіант більше недоступний. Оновіть сторінку та оберіть знову.",
  "board.banner.completed": "Завершено ігор",
  "board.banner.goals": "Голи в завершених іграх",

  "spectator.preview": "Перед матчем",
  "spectator.pendingTeams": "Порівняння з’явиться, коли визначаться обидві команди.",
  "spectator.previewNote": "Результати в цьому дивізіоні до запланованого початку матчу.",
  "spectator.noHistory": "У цьому дивізіоні ще немає попередніх результатів.",
  "spectator.record": "Перемоги: {won} · поразки: {lost} · нічиї: {drawn}",
  "spectator.points": "{for} забито · {against} пропущено · різниця {diff}",
  "spectator.form": "Останні п’ять матчів · від давніших",
  "spectator.common": "Спільні суперники",
  "spectator.progression": "Шлях у турнірі",
  "spectator.groupStage": "Груповий етап",
  "spectator.swissStage": "Швейцарська система",
  "spectator.scorePerspective": "У рахунку першою вказана команда {team}",
  "spectator.against": "Проти",
  "spectator.possibleRounds": "Можливі наступні матчі ({count})",
  "spectator.allStageGames": "Усі матчі ({count})",
  "spectator.fewerGames": "Згорнути",
  "spectator.pathNote": "Можливі матчі залежать від місця в групі та попередніх результатів.",
  "spectator.bracketGame": "Матч сітки",
  "spectator.poolGame": "Матч групи",
  "spectator.completed": "Завершено",
  "spectator.nextConfirmed": "Наступний визначений матч",
  "spectator.confirmed": "Визначено",
  "spectator.possible": "Можливо · участь ще не визначена",
  "spectator.filter.day": "День",
  "spectator.filter.team": "Команда",
  "spectator.filter.division": "Дивізіон",
  "spectator.filter.field": "Поле",
  "spectator.all": "Усі",
  "spectator.unavailableFilter": "Недоступний вибір",
  "spectator.filters": "Фільтри розкладу",
  "spectator.showing": "Матчів: {shown} з {total}",
  "spectator.clear": "Скинути фільтри",
  "spectator.teamFilterNote":
    "Лише визначені матчі команди. Можливі наступні раунди дивіться на сторінці команди.",
  "spectator.performances": "Яскраві виступи",
  "spectator.highlights": "Найцікавіше",
  "spectator.coverage": "Записи розіграшів доступні для {recorded} із {total} завершених матчів.",
  "spectator.highlightsNote":
    "Найбільше записаних голів + асистів за один матч. Повнота запису різниться; це статистика атаки, а не рейтинг MVP. Однакові результати показано разом.",
  "spectator.noCredits": "Для цих матчів ще немає записаних голів або асистів гравців.",
  "spectator.contribution": "Голи: {goals} · асисти: {assists}",
  "spectator.sideCoverage": "Авторів визначено для {credited} із {scored} голів команди.",
  "spectator.viewMatch": "Переглянути матч",
  "spectator.partnerships": "Результативні зв’язки",
  "spectator.connections": "Зв’язок асист → гол за матч: {count}",
  "spectator.closeGames": "Напружені матчі",
  "spectator.closeNote": "Різниця у фінальному рахунку: не більше двох голів.",
  "spectator.noMatches": "За цими фільтрами матчів немає. Скиньте їх або змініть вибір.",
  "spectator.pulse": "Пульс турніру",
  "spectator.progress": "Завершено {completed} / {total} матчів",
  "spectator.live": "Наживо: {count}",
  "spectator.liveUnavailable": "Статус наживо неповний · відновлюємо зв’язок",
  "spectator.goals": "Голи у завершених матчах: {count}",

  "tournamentPlayers.all": "Усі гравці",
  "tournamentPlayers.title": "Гравці турніру",
  "tournamentPlayers.back": "До лідерів",
  "tournamentPlayers.intro":
    "Знайдіть себе у заявках команд турніру, навіть якщо статистику ще не записано.",
  "tournamentPlayers.search": "Ім’я, номер або команда",
  "tournamentPlayers.division": "Дивізіон",
  "tournamentPlayers.allDivisions": "Усі дивізіони",
  "tournamentPlayers.showing": "Показано {shown} із {total} записів",
  "tournamentPlayers.rateShort": "/І",
  "tournamentPlayers.rateLabel": "{stat} за гру команди",
  "tournamentPlayers.rank": "Місце",
  "tournamentPlayers.teamGames": "Матчі команди",
  "tournamentPlayers.rankNote":
    "Місця визначаються серед усіх гравців дивізіону й не змінюються під час фільтрування. Гравці без записаних голів чи асистів не мають місця в рейтингу.",
  "tournamentPlayers.noMatches":
    "Гравців не знайдено. Спробуйте інше ім’я, номер чи команду або очистьте фільтри.",
  "tournamentPlayers.empty": "У заявках команд турніру ще немає гравців.",
  "tournamentPlayers.merged": "Об’єднані записи у заявках",

  "announcements.title": "Оголошення",
  "announcements.pinned": "Закріплено",
  "announcements.updated": "Оновлено {when}",
  "announcements.until": "Діє до {when} · за місцевим часом турніру",
  "eventInfo.group.lostFound": "Загублені речі",
  "eventInfo.detail.lostFoundInstructions": "Де залишити або забрати речі",
  "eventInfo.detail.lostFoundName": "Контактна особа щодо загублених речей",
  "eventInfo.detail.lostFoundPhone": "Телефон щодо загублених речей",
  "eventInfo.detail.lostFoundEmail": "Електронна пошта щодо загублених речей",
  "eventInfo.detail.lostFoundLink": "Посилання для зв’язку щодо загублених речей",

  "eventInfo.payBy": "Сплатити до {when}",
  "eventInfo.essentials": "Організаційна інформація",
  "eventInfo.localTime": "Увесь час вказано за місцевим часом турніру.",
  "eventInfo.group.organiser": "Контакти організатора",
  "eventInfo.group.firstAid": "Перша допомога",
  "eventInfo.group.keyTimes": "Важливі події",
  "eventInfo.group.amenities": "Зручності",
  "eventInfo.group.fees": "Внески та оплата",
  "eventInfo.detail.organiserName": "Контактна особа",
  "eventInfo.detail.organiserPhone": "Телефон організатора",
  "eventInfo.detail.organiserEmail": "Електронна пошта організатора",
  "eventInfo.detail.organiserLink": "Посилання для зв’язку",
  "eventInfo.detail.firstAidLocation": "Пункт першої допомоги",
  "eventInfo.detail.firstAidName": "Контакт з питань першої допомоги",
  "eventInfo.detail.firstAidPhone": "Телефон для першої допомоги",
  "eventInfo.detail.firstAidEmail": "Електронна пошта для першої допомоги",
  "eventInfo.detail.firstAidLink": "Посилання для зв’язку щодо першої допомоги",
  "eventInfo.detail.checkIn": "Реєстрація на місці",
  "eventInfo.detail.captainsMeeting": "Зустріч капітанів",
  "eventInfo.detail.awardsCeremony": "Церемонія нагородження",
  "eventInfo.detail.showers": "Душові",
  "eventInfo.detail.changingRooms": "Роздягальні",
  "eventInfo.detail.food": "Харчування",
  "eventInfo.detail.accessibility": "Доступність",
  "eventInfo.detail.feeAmount": "Вартість участі",
  "eventInfo.detail.feeIncludes": "Що входить у внесок",
  "eventInfo.detail.paymentInstructions": "Як оплатити",
  "eventInfo.detail.paymentDeadline": "Кінцевий термін оплати",
  "players.loadMore": "Завантажити ще",
  "players.allLoaded": "Показано всіх гравців за вашим запитом.",
  "eventInfo.practical": "Корисна інформація",
  "eventInfo.media": "Фото та відео",
  "eventInfo.photographer": "Фотограф",
  "eventInfo.videographer": "Відеограф",
  "eventInfo.both": "Фото та відео",
  "eventInfo.pending": "Посилання на фото та відео з’являться тут, коли організатор їх додасть.",

  "board.info.divisions": "Дивізіони",
  "board.info.joinTitle": "Участь у турнірі",
  "board.info.joinHint": "Капітан або менеджер подає команду зі сторінки свого клубу.",
  "board.info.chooseClub": "Обрати клуб",
  "board.info.findTeam": "Шукаєте команду?",
  "board.info.pickupHint": "Перегляньте оголошення пікапів.",
  "board.info.conditions": "Умови та формат",
  "board.info.conditionsHint": "Тривалість ігор, Дух гри та правила",

  "board.info.locations": "Локації",
  "board.info.chooseMap": "Відкрити на мапі",
  "board.info.starts": "Початок",

  "nav.tournaments": "Турніри",
  "nav.browse": "Навігація SCORE",
  "nav.onPage": "На цій сторінці",
  "nav.access": "Ваш доступ",
  "nav.sections": "{name}: розділи",
  "nav.chooseSection": "Вибрати розділ: {name}",
  "nav.tournament": "Турнір",
  "nav.teamWorkspace": "Команда на турнірі",
  "nav.clubWorkspace": "Сторінка клубу",
  "nav.publicClub": "Публічний профіль клубу",
  "nav.scoreConnection": "Оновлення рахунку",
  "nav.connecting": "Підключення",
  "nav.connected": "Підключено",
  "nav.reconnecting": "Відновлення зв’язку",
  "nav.ended": "Завершений",
  "nav.registrationOpen": "Реєстрацію відкрито",
  "players.jerseyNumber": "Ігровий номер {number}",
  "nav.draft": "Чернетка",
  "nav.archived": "В архіві",

  // The front page's card (2026-09-16): a squad's next game, the game on the
  // field, the fresh result; for everyone else, what the event plays now.
  "front.next.eyebrow": "Наступний матч",
  "front.next.today": "сьогодні",
  "front.next.tomorrow": "завтра",
  "front.next.startingNow": "починається",
  "front.next.inMinutes": "за {n} хв",
  "front.next.inHours": "за {h} год {m} хв",
  "front.next.onField": "На полі · {field}",
  "front.next.played": "Зіграно · {time}",
  "front.next.won": "Перемога",
  "front.next.lost": "Поразка",
  "front.next.drawn": "Нічия",
  "front.next.then": "Далі: {opponent} · {time} · {field}",
  "front.next.tbd": "Суперник ще не визначений",
  "front.next.teamSchedule": "Розклад команди",
  "front.next.schedule": "Розклад",
  "front.next.onFields": "На полях",
  "front.next.nextGame": "Наступна гра · {name}",
  "front.next.nextGames": "Наступні ігри · {name}",
  "front.next.lastResult": "Останній результат · {name}",

  "error.team-leader-ineligible":
    "Оберіть активного учасника клубу або пов’язаного гравця зі складу цієї команди.",
  "error.invite-account-mismatch":
    "Це запрошення для іншого акаунту. Увійдіть в акаунт, якому його надіслали.",
  "eventPickup.directoryIntro": "Знайдіть команду або гравців на цей турнір.",
  "eventPickup.findTeam": "Знайти команду",
  "eventPickup.findPlayers": "Знайти гравців",
  "eventPickup.forPlayers": "Для гравців",
  "eventPickup.forTeams": "Для команд",
  "eventPickup.lookingForTeam": "Шукаєте команду?",
  "eventPickup.yourAvailability": "Ви шукаєте команду",
  "eventPickup.listHint": "Розкажіть про себе, щоб команди могли запросити вас на цей турнір.",
  "eventPickup.alreadyAgreed": "Уже домовилися?",
  "eventPickup.lookingForPlayers": "Потрібні гравці?",
  "eventPickup.loginRecruit": "Увійти, щоб знайти гравців",
  "eventPickup.recruitHint":
    "Запрошуйте гравців зі списку. На сторінці своєї команди можна оголосити пошук пікапів або створити посилання-запрошення.",
  "eventPickup.teamHint":
    "Оголосіть пошук пікапів від своєї команди або запросіть гравця, з яким уже домовилися.",
  "eventPickup.teamsEmptyTitle": "Команди ще формуються",
  "eventPickup.teamsEmptyHint":
    "Тут з’являться команди, яким потрібні пікапи. Додайте себе до списку гравців, щоб вони могли вас запросити.",
  "eventPickup.playersEmptyTitle": "Гравці ще не відгукнулися",
  "eventPickup.playersEmptyHint":
    "Тут з’являться гравці, які шукають команду на цей турнір. Уже знаєте, кого запросити? Їх можна знайти за ім’ям.",
  "eventPickup.wantToPlay": "Хочете зіграти на цьому турнірі?",
  "eventPickup.intro": "Знайдіть команду або скажіть, що готові зіграти.",
  "eventPickup.availableAction": "Хочу зіграти пікапом",
  "eventPickup.editAvailability": "Редагувати мою доступність",
  "eventPickup.login": "Увійти, щоб знайти команду",
  "eventPickup.listed": "Ви у списку гравців, які шукають команду на цей турнір.",
  "eventPickup.closed": "Пошук пікапів на цей турнір закрито.",
  "eventPickup.teams": "Команди шукають гравців",
  "eventPickup.noTeams": "Команд, які шукають пікапів, ще немає.",
  "eventPickup.players": "Гравці шукають команду",
  "eventPickup.playersHint": "Запросіть до свого складу.",
  "eventPickup.registerHint":
    "Зареєструйте склад зі сторінки свого клубу, щоб запрошувати гравців.",
  "eventPickup.myClubs": "Мої клуби",
  "eventPickup.noPlayers": "Ще ніхто не повідомив, що шукає команду на цей турнір.",
  "eventPickup.availabilityHint":
    "Ваше ім’я та примітку побачать команди турніру. Прибрати себе можна будь-коли.",
  "eventPickup.division": "Бажаний дивізіон",
  "eventPickup.anyDivision": "Будь-який дивізіон",
  "eventPickup.aboutYou": "Що командам варто знати про вас?",
  "eventPickup.removeAvailability": "Більше не шукаю команду",
  "eventPickup.invited": "Запрошення надіслано",
  "eventPickup.browseEvent": "Пікапи на цей турнір",
  "eventPickup.registerNeeds": "Нам потрібні пікапи",
  "eventPickup.registerNeedsHint":
    "Показувати цей склад на сторінці пікапів турніру після схвалення заявки.",

  // Pickups agreed off the platform (2026-09-15): a squad invites anybody, a
  // player asks any squad, a squad shares a single-use link.
  "pickup.mark": "Пікап",
  "pickup.markHint": "У складі цієї команди лише на цьому турнірі.",
  "pickup.toggle": "Пікап: {player}",
  "pickupInvite.title": "Запросити гравця",
  "pickupInvite.hint": "Для домовленостей на полі чи в чаті.",
  "pickupInvite.consent":
    "Гравець отримає запрошення. У складі нічого не зміниться, доки гравець його не прийме.",
  "pickupInvite.searchHint": "Введіть щонайменше дві літери.",
  "pickupInvite.empty":
    "Нікого не знайдено. Гравця з прихованим профілем або без облікового запису запросіть посиланням-запрошенням.",
  "pickupInvite.available": "Шукає команду",
  "pickupInvite.invited": "Запрошено",
  "pickupInvite.declined": "Запрошення відхилено",
  "pickupInvite.invite": "Запросити",
  "pickupInvite.onlyPeople": "Запрошують капітан, менеджер, спіріт-капітан або організатор.",
  "pickupLinks.title": "Посилання-запрошення",
  "pickupLinks.hint":
    "Для гравця, якого не знаходить пошук. Одне посилання - один гравець, 7 днів.",
  "pickupLinks.create": "Створити посилання",
  "pickupLinks.created":
    "Надішліть це посилання гравцеві. Його видно лише зараз: якщо загубите, створіть нове.",
  "pickupLinks.copy": "Скопіювати посилання",
  "pickupLinks.copyWeb": "Скопіювати веб-посилання",
  "pickupLinks.webHint": "Веб-посилання - для тих, хто відкриває не в Telegram.",
  "pickupLinks.active": "Діє до {date}",
  "pickupLinks.untilEventEnd": "Діє до кінця турніру, {date}",
  "pickupLinks.used": "Використано: {name}",
  "pickupLinks.by": "Створено: {who}",
  "pickupLinks.revoke": "Скасувати",
  "pickupLinks.revoked": "Скасовано",
  "pickupLinks.none": "Ще немає посилань.",
  "pickupTeam.awaitingPlayer": "Чекають на відповідь гравця",
  "pickupTeam.awaitingTeam": "Заявки гравців",
  "flow.invitationForYou":
    "Команда запрошує вас зіграти пікапом. У складі ви з’явитеся лише після того, як приймете запрошення.",
  "flow.requestForTeam": "Гравця додадуть до складу лише після схвалення команди.",
  "flow.waitingForPlayer": "Чекає на відповідь гравця.",
  "flow.waitingForTeam": "Чекає на рішення команди.",
  "flow.viaLink": "За посиланням-запрошенням",
  "eventPickup.yours": "Ваші запрошення та заявки",
  "eventPickup.askAny": "Попроситися в команду",
  "eventPickup.askAnyHint": "Домовилися на полі чи в чаті? Заявку можна подати будь-якій команді.",
  "eventPickup.linksInHub": "Посилання-запрошення створюються на сторінці команди:",
  "askSquad.listed": "Шукають пікапів",
  "askSquad.noDivision": "Без дивізіону",
  "askSquad.pending": "Уже очікує відповіді",
  "askSquad.change": "Інша команда",
  "askSquad.consent":
    "Команда отримає заявку. У складі ви з’явитеся лише після того, як команда її схвалить.",
  "askSquad.none": "На турнірі ще немає команд, які можуть прийняти пікапа.",
  "pickupLink.eyebrow": "Запрошення в команду",
  "pickupLink.invites": "Вас запрошують зіграти пікапом за {team}.",
  "pickupLink.consent": "У склад потрапите після прийняття. Ваші клуби не зміняться.",
  "pickupLink.signIn": "Спершу увійдіть: запрошення прийме ваш обліковий запис.",
  "pickupLink.telegram": "Увійти через Telegram",
  "pickupLink.as": "Ви увійшли як {label}.",
  "pickupLink.accept": "Прийняти запрошення",
  "pickupLink.notNow": "Не зараз",
  "pickupLink.done": "Готово: ви у складі {team}.",
  "pickupLink.openEvent": "Відкрити турнір",
  "pickupLink.missing":
    "Посилання не знайдено. Відкрийте його ще раз з повідомлення, яке вам надіслали.",
  "pickupLink.numberHint": "Ваш номер у складі цієї команди на турнірі. Можна залишити порожнім.",
  "error.pickup-declined":
    "Цей гравець відхилив запрошення вашої команди на цьому турнірі. Гравець може сам попроситися в команду.",
  "error.pickup-invite-limit": "Команда вичерпала денний ліміт запрошень. Спробуйте пізніше.",
  "error.pickup-link-invalid": "Це посилання-запрошення не працює. Попросіть у капітана нове.",
  "error.pickup-link-used": "За цим посиланням уже приєдналися. Попросіть у капітана нове.",
  "error.support-closed": "Цей чат уже завершено. Відкрийте новий.",

  "error.pickup-already-rostered": "Цей гравець уже у складі цієї команди на турнірі.",
  "error.roster-full": "У складі вже є максимально допустимі 40 гравців.",
  "flow.withdraw": "Відкликати",
  "flow.entries": "Заявки на турніри",
  "flow.review": "Заявки потребують схвалення",
  "flow.reviewHint": "Подані команди залишаються приватними, доки організатор їх не схвалить.",
  "flow.pending": "Очікує схвалення",
  "flow.accepted": "Схвалено",
  "flow.declined": "Відхилено",
  "flow.withdrawn": "Відкликано",
  "flow.expired": "Термін минув",
  "flow.accept": "Схвалити",
  "flow.decline": "Відхилити",
  "flow.note": "Примітка для гравця або команди",
  "flow.requests": "Заявки та запрошення",
  "flow.link": "Повʼязати мій запис гравця",
  "flow.linkHint":
    "Оберіть свій запис в імпортованому складі. Капітан, менеджер або організатор підтвердить його. Ваші ролі в клубах збережуться.",
  "flow.club": "Клуб",
  "flow.event": "Турнір",
  "flow.library": "Склад клубу",
  "flow.team": "Команда на турнірі",
  "flow.player": "Запис гравця",
  "flow.send": "Надіслати заявку",
  "flow.sent": "Заявку надіслано",
  "flow.pickups": "Пікапи",
  "flow.pickupHint":
    "Знайдіть команду для участі в турнірі. Участь у вашому основному клубі збережеться.",
  "flow.needs": "Шукає пікапів",
  "flow.noPickups": "Наразі немає команд, які шукають пікапів.",
  "flow.requestPickup": "Подати заявку на пікап",
  "flow.invitePickup": "Запросити пікапа",
  "flow.invite": "Надіслати запрошення",
  "flow.pickupRecruit": "Гравець подає заявку або ви запрошуєте; склад зміниться після згоди обох.",
  "flow.stopLooking": "Завершити пошук пікапів",
  "flow.startLooking": "Позначити: шукаємо пікапів",
  "flow.number": "Ігровий номер",
  "flow.message": "Повідомлення",
  "flow.linkKind": "Звʼязок із записом гравця",
  "flow.pickupKind": "Пікап",
  "flow.invitation": "Запрошення",
  "flow.request": "Заявка",
  "flow.roster": "Поданий склад",
  "flow.noRequests": "Немає заявок на розгляді",
  "flow.reviewPlayers": "Розглянути заявки гравців",

  "players.title": "Гравці",
  "players.intro": "Люди, клуби та їхня історія на турнірах.",
  "players.search": "Знайти гравця за ім’ям",
  "players.empty": "Гравців не знайдено. Спробуйте інше ім’я або фільтр клубу.",
  "players.noClub": "Без поточного клубу",
  "players.club": "Клуб",
  "players.allClubs": "Усі клуби",
  "players.withoutClub": "Без клубу",
  "players.narrow": "Показано перші 60 гравців. Уточніть пошук.",
  "players.profile": "Профіль гравця",
  "players.unavailable": "Профіль недоступний або його не вдалося завантажити.",
  "players.recordHint": "Клуби, склади та записані результати.",
  "players.events": "Турніри",
  "players.rosteredGames": "Ігор у ростері",
  "players.goals": "Голи",
  "players.assists": "Асисти",
  "players.coverage":
    "Авторів голів записано для {credited} із {total} поінтів команд у збережених іграх. Склад не підтверджує вихід на поле; незаписані дії не означають нуль.",
  "players.history": "Історія турнірів",
  "players.noHistory": "Складів на публічних турнірах ще немає.",
  "players.eventStats": "Ігор у заявці: {games} · Голи: {goals} · Асисти: {assists}",
  "players.currentClubs": "Поточні клуби",
  "history.playerHint":
    "Записані голи й асисти; без даних показуємо прочерк. Заявка на гру не підтверджує час на полі.",
  "history.rosteredGames": "Ігор у заявці",
  "history.allSquads": "За всі команди на цьому турнірі",
  "history.wins": "Перемоги",
  "history.draws": "Нічиї",
  "history.losses": "Поразки",
  "history.diff": "Різниця голів",
  "history.recordUnavailable": "Результати недоступні",
  "history.noResults": "Немає записаних результатів",

  "front.login": "Увійти",
  "front.account": "Мій акаунт",
  "join.share": "Поділитися клубом у Telegram",
  "join.copyLink": "Скопіювати посилання клубу",
  "join.copyManually": "Автоматичне копіювання недоступне. Скопіюйте виділене посилання нижче.",
  "join.yourNumber": "Ви у цьому складі під номером {number}.",
  "join.spiritOwner": "Оцінки духу гри від команди подає капітан або спіріт-капітан.",

  "join.title": "Приєднатися до клубу",
  "join.member": "Ви учасник клубу",
  "join.openClub": "Відкрити кабінет клубу",
  "join.pending": "Заявка очікує розгляду · {club}",
  "join.abandon": "Відкликати заявку",
  "join.hint": "Капітан клубу розгляне заявку.",
  "join.apply": "Подати заявку",
  "join.signIn": "Увійти, щоб приєднатися",
  "join.as": "Хочу приєднатися як",
  "join.player": "Гравець (у складі)",
  "join.support": "Підтримка (поза складом)",
  "join.createAs": "Ви в складі?",
  "join.createPlayer": "Так, я граю",
  "join.createSupport": "Ні, не граю",
  "join.createAsHint": "Тренер чи підтримка - «Ні». Капітаном станете ви.",
  "join.createNameHint": "Латиницею, як у паспорті.",
  "join.number": "Ігровий номер",
  "join.message": "Повідомлення клубу (необов’язково)",
  "join.create": "Створити клуб",
  "join.signInCreate": "Увійти, щоб створити клуб",
  "join.createHint": "Клуб уже є в каталозі? Подайте заявку до нього.",
  "join.name": "Назва клубу",
  "join.short": "Короткий код",
  "join.city": "Місто",
  "join.color": "Колір команди",
  "join.requests": "Заявки на вступ",
  "photo.title": "Фото",
  "photo.hint":
    "Показується у вашому публічному профілі гравця. Портрет - голова і плечі; більше нічого з файлу не читається.",
  "photo.upload": "Завантажити фото",
  "photo.replace": "Замінити",
  "photo.remove": "Прибрати",
  "photo.editorTitle": "Ваше фото",
  "photo.editorHint":
    "Тягніть, щоб посунути; зум - пальцями або повзунком; поверніть чи віддзеркальте. Світла смуга - те, що видно на широкому екрані: пересуньте її на обличчя. Телефон показує всю рамку.",
  "photo.zoom": "Зум",
  "photo.focus": "Широкий екран",
  "photo.rotate": "Повернути",
  "photo.flip": "Віддзеркалити",
  "photo.use": "Використати це фото",
  "photo.unreadable": "Цей файл не вдалося прочитати як зображення.",
  "photo.tooLarge": "Це фото надто складне, щоб уміститися; спробуйте тісніше кадрування.",
  "photo.saved": "Фото збережено.",
  "photo.removed": "Фото прибрано.",
  "photo.removedBy": "{by} прибрав(-ла) ваше фото",
  "photo.reasonLabel": "Причина",
  "photo.dismiss": "Зрозуміло",
  "photo.moderate": "Прибрати фото",
  "photo.moderateTitle": "Прибрати фото {label}?",
  "photo.moderateHint": "Людина дізнається, хто прибрав фото і чому, і зможе поставити інше.",
  "photo.reason": "Причина, словами, які людина прочитає",
  "photo.moderated": "Фото прибрано; людину повідомлено.",
  "join.noRequests": "Немає заявок на розгляді.",
  "join.rosterRow": "Пов’язати з гравцем у складі",
  "join.newPlayer": "Новий гравець",
  "join.existingPlayer": "Вже є у складі",
  "join.newPlayerHint":
    "Вкажіть ім’я та прізвище для складу клубу. Після схвалення запис гравця буде створено й пов’язано з акаунтом цієї людини.",
  "join.firstNameEnglish": "Ім’я (англійською)",
  "join.lastNameEnglish": "Прізвище (англійською)",
  "join.englishNameHint": "Латиницею, як у паспорті: так ви будете у складі.",
  "join.englishNameError": "Використовуйте англійські літери, пробіли, дефіси або апострофи.",
  "join.firstName": "Ім’я",
  "join.lastName": "Прізвище",
  "join.nameTooLong": "Ім’я та прізвище разом із пробілом мають містити не більше 40 символів.",
  "join.selectPlayer": "Оберіть гравця",
  "join.noUnlinkedPlayers":
    "Усі гравці у складі вже пов’язані з акаунтами або склад порожній. Оберіть «Новий гравець», щоб додати цю людину.",
  "join.note": "Відповідь заявнику (необов’язково)",
  "join.accept": "Схвалити",
  "join.decline": "Відхилити",
  "join.myClubs": "Мої клуби та ролі",
  "join.noMemberships": "Ваш профіль готовий. Знайдіть клуб для вступу або створіть новий.",
  "join.findClubs": "Знайти клуби",
  "error.already-member": "Ви вже учасник цього клубу.",
  "error.application-pending":
    "У вас уже є заявка на розгляді. Відкличте її, перш ніж подавати іншу.",
  "error.application-missing": "Цю заявку вже розглянуто або відкликано.",
  "error.player-claimed": "Цей гравець уже пов’язаний з іншим обліковим записом.",

  // ---------- common ----------
  "common.save": "Зберегти",
  "common.cancel": "Скасувати",
  "common.close": "Закрити",
  // The Stepper's -/+ buttons, named for a screen reader with the row's own label.
  "stepper.less": "{label}: на один менше",
  "stepper.more": "{label}: на один більше",
  "common.delete": "Видалити",
  "common.remove": "Прибрати",
  "common.edit": "Редагувати",
  "common.add": "Додати",
  "common.back": "Назад",
  "common.open": "Відкрити",
  "common.clear": "Очистити",
  "common.copy": "Копіювати",
  "common.copied": "Скопійовано",
  "common.loading": "Завантаження…",
  "common.saving": "Збереження…",
  "common.done": "Готово",
  "common.none": "Немає",
  "common.notSet": "Не задано",
  "common.yes": "Так",
  "common.no": "Ні",
  "common.retry": "Спробувати ще раз",
  "common.refresh": "Оновити",
  "common.scrollToEnd": "До кінця",
  "common.scrollToStart": "До початку",

  // ---------- language switcher ----------
  "locale.label": "Мова",
  "locale.uk": "Українська",
  "locale.en": "English",
  "locale.ukShort": "УКР",
  "locale.enShort": "ENG",

  // ---------- theme switcher ----------
  "theme.label": "Тема",
  "theme.dark": "Темна",
  "theme.light": "Світла",
  "theme.toLight": "Увімкнути світлу тему",
  "theme.toDark": "Увімкнути темну тему",

  // ---------- landing ----------

  // ---------- staff gate ----------
  "gate.eyebrow": "ДОСТУП ДЛЯ ПЕРСОНАЛУ",
  "gate.wrongEyebrow": "НЕ ТЕ ПОСИЛАННЯ",
  "gate.field": "Посилання доступу",
  "gate.placeholder": "вставте своє посилання",
  "gate.unlock": "Відкрити",
  "gate.checking": "Перевіряємо…",
  "gate.hintDefault": "Відкрийте посилання, яке надіслав організатор, або вставте його нижче.",
  "gate.hintRevoked": "Це посилання вимкнули. Попросіть в організатора нове.",
  "gate.hintOffline":
    "Немає з'єднання. Перевірте інтернет і спробуйте ще раз - посилання нікуди не зникло.",
  "gate.hintExpired": "Термін дії цього посилання минув. Попросіть в організатора нове.",
  "gate.hintThrottled": "Забагато спроб із цього пристрою. Зачекайте хвилину і спробуйте ще раз.",
  "gate.hintCookieless":
    "З посиланням усе гаразд, але цей браузер не зберіг вхід. Вимкніть приватний перегляд або дозвольте файли cookie для цього сайту, а тоді відкрийте посилання ще раз.",
  "gate.rejected": "Це посилання не підходить. Перевірте, чи скопіювали його повністю.",
  "gate.wrongLink": "Ваше посилання працює, але воно не відкриває цю сторінку. Воно для:",
  "gate.wrongLinkOther":
    "Є посилання саме для цієї сторінки? Вставте його сюди - воно відкриється поруч із тим, що вже є в цьому браузері.",
  "gate.wrongLinkFallback": "іншої сторінки",
  "gate.openBridge": "Відкрити міст OBS: {field}",
  "gate.openField": "Відкрити {field}",
  "gate.openTeam": "Відкрити сторінку команди",
  "gate.openAdmin": "Відкрити керування турніром",

  // ---------- what a credential covers ----------
  // Дубльовані з `grant.role.*` навмисно: цей набір живе в core, бо ворота
  // малюються до того, як під'їде staff-словник.
  "gate.role.organiser": "Організатор",
  "gate.role.scorekeeper": "Оператор",
  "gate.role.bridge": "OBS Bridge",
  "gate.role.participant": "Капітан команди",
  "gate.role.superadmin": "Платформа",

  // ---------- кілька посилань в одному браузері ----------
  "gate.wrongLinkMany": "Жодне з ваших посилань не відкриває цю сторінку. Ось що у вас є:",
  "gate.lostCredential":
    "Посилання, яке відкривало цю сторінку - {who} ({what}) - більше не працює.",
  "gate.confirmEyebrow": "ВІДКРИТИ ТУТ?",
  "gate.confirmOpens": "Це посилання відкриває:",
  "gate.confirmReplaces":
    "У цьому браузері вже є посилання для того самого: {who} ({what}). Якщо відкрити нове, старе тут перестане діяти, а показати його ще раз неможливо.",
  "gate.confirmCopyFirst":
    "Посилання показують лише один раз. Скопіюйте його, перш ніж вирішувати - тоді воно у вас залишиться.",
  "gate.confirmCopy": "Скопіювати це посилання",
  "gate.confirmOpen": "Відкрити нове посилання",
  "gate.confirmKeep": "Залишити те, що вже є",
  "gate.signInAccount": "Увійти з обліковим записом",
  "gate.role.captain": "Капітан команди",
  "gate.role.spirit": "Спіріт-капітан",
  "gate.role.manager": "Менеджер команди",
  "gate.role.account": "Обліковий запис",

  // ---------- вхід і вихід ----------
  "session.title": "Ви увійшли як",
  "session.also": "Також тут",
  "session.signOutThis": "Вийти",
  "session.signOutAll": "Вийти з усіх ({n})",
  "session.changePassword": "Змінити пароль",
  "session.account": "Обліковий запис",
  "session.accountHint": "Вихід лише з цього браузера. Ваші членства залишаються.",
  "session.signOutHint": "Вихід лише з цього браузера - саме посилання далі працює.",

  // ---------- error sentences (shared/error-codes.ts) ----------
  "error.invalid-payload": "Дані не пройшли перевірку. Спробуйте ще раз.",
  "error.not-found": "Не знайдено.",
  "error.server-error": "Помилка сервера. Спробуйте ще раз.",
  "error.forbidden": "Немає доступу.",
  "error.unauthorized": "Потрібно увійти.",
  "error.expected-websocket": "Очікувалося з'єднання WebSocket.",
  "error.reauth-required": "Підтвердьте пароль ще раз.",
  "error.invalid": "Не вдалося увійти.",
  "error.revoked": "Це посилання вимкнули.",
  "error.expired": "Термін дії цього посилання минув.",
  "error.would-replace": "Це посилання замінило б інше, яке вже є в цьому браузері.",
  "error.invite-accepted": "Це запрошення вже використано.",
  "error.need-registration": "Заповніть форму, щоб створити обліковий запис.",
  "error.account-disabled": "Цей обліковий запис вимкнено.",
  "error.account-missing": "Такого облікового запису немає.",
  "error.rate": "Забагато спроб. Зачекайте хвилину.",
  "error.team-referenced": {
    one: "{count} гра в розкладі досі посилається на цю команду. Спершу приберіть її з розкладу.",
    few: "{count} гри в розкладі досі посилаються на цю команду. Спершу приберіть їх з розкладу.",
    many: "{count} ігор у розкладі досі посилаються на цю команду. Спершу приберіть їх з розкладу.",
    other:
      "{count} ігор у розкладі досі посилаються на цю команду. Спершу приберіть їх з розкладу.",
  },
  "error.field-has-games": {
    one: "На цьому полі ще запланована {count} гра.",
    few: "На цьому полі ще заплановані {count} гри.",
    many: "На цьому полі ще заплановано {count} ігор.",
    other: "На цьому полі ще заплановано {count} ігор.",
  },
  "error.field-last": "У турнірі має лишитися хоча б одне поле.",
  "error.team-exists": "У цьому турнірі така команда вже є.",
  "error.club-exists": "Клуб із таким id уже існує.",
  "error.club-owned": "У цього клубу вже є люди. Капітан запрошує зі сторінки клубу.",
  "error.team-not-in-library": "Цієї команди ще немає в бібліотеці. Спершу додайте її туди.",
  "error.club-missing": "Такого клубу немає.",
  "error.too-many-games": "Забагато ігор за один раз.",
  "error.unknown-team": "Такої команди немає.",
  "error.person-already-merged": "Одного з цих гравців уже об'єднано з {clash}.",
  "error.game-off-schedule": "Цієї гри вже немає в розкладі.",
  "error.erase-refused":
    "У цієї гри є записаний список поінтів, і це збереження його зітре. Спершу підтвердьте стирання в редакторі.",
  "error.game-not-scheduled": "Цієї гри немає в розкладі.",
  "error.game-not-played": "Цю гру ще не завершено.",
  "error.opponent-undecided": "У цій грі ще не визначений суперник вашої команди.",
  "error.team-not-in-game": "Цієї команди немає в цій грі, або суперник ще не визначений.",
  "error.spirit-off": "Оцінювання духу гри вимкнене.",
  "error.spirit-filed":
    "Ви вже надіслали цю оцінку. Якщо треба змінити, зверніться до організатора.",
  "error.push-off": "Сповіщення не налаштовані на цьому сервері.",
  "error.cards-off": "Картки результатів не налаштовані на цьому сервері.",
  "error.self-scoring-off": "Самооцінювання вимкнене.",
  "error.superadmin-exists": "Суперадміністратор уже існує.",
  "error.email-registered": "Ця пошта вже зареєстрована.",
  "error.superadmin-last": "Це останній активний суперадміністратор. Спершу створіть іншого.",
  "error.superadmin-self": "Не можна вимкнути власний обліковий запис.",
  "error.superadmin-missing": "Такого суперадміністратора немає.",
  "error.slug-taken": "Цю адресу вже має інший турнір.",
  "error.slug-reserved": "Це слово застережене застосунком. Виберіть іншу адресу.",
  "error.slug-frozen": "Адресу опублікованого турніру вже не змінити.",
  "error.tournament-missing": "Такого турніру немає.",
  "error.tournament-archived": "Турнір в архіві й не приймає змін.",
  "tournament.deadlines": "Терміни заявок",
  "tournament.deadlineNeedsZone":
    "Оберіть часовий пояс, щоб увімкнути терміни. Без нього збережені терміни не діють.",
  "tournament.deadlineHint":
    "Час указано в часовому поясі турніру. Реєстрація закривається у вказану хвилину; організатори можуть виправляти заблоковані склади. Очистіть дату, щоб прибрати обмеження.",
  "tournament.registrationCloses": "Закриття реєстрації",
  "tournament.rosterLocks": "Блокування складів",
  "tournament.registrationUntil": "Реєстрація до {when} ({zone})",
  "tournament.rosterUntil": "Зміни складу до {when} ({zone})",
  "error.roster-locked": "Склад заблоковано. Зверніться до організатора, щоб внести зміни.",
  "error.registration-closed": "Реєстрацію на цей турнір закрито.",
  "error.outbox-off": "Тестова скринька є лише в режимі журналу.",
  "error.telegram-off": "Вхід через Telegram не налаштовано на цьому сервері.",
  "error.telegram-invalid": "Telegram не підтвердив цей вхід. Відкрийте застосунок ще раз.",
  "error.telegram-taken": "Цей Telegram уже підключено до іншого облікового запису.",
  "error.last-credential": "Це єдиний спосіб входу в цей обліковий запис.",
  "error.already-adopted": "Наявний турнір уже зареєстровано.",

  // ---------- public board ----------
  // Kept SHORT on purpose: «ЖИВИЙ РАХУНОК» wrapped the dark band onto two lines
  // at 375px, and the sub-tab strip below it is stickied against a one-line
  // header. The rule is to rewrite the string, never to shrink NXT.
  "board.title": "SCORE",

  // ---------- the front page and the /t/$slug layout (V2 Phase 2) ----------
  "front.eyebrow": "ТУРНІРИ",
  "front.intro": "Від першого пулу до фінального поінта.",
  "front.explore": "Розклад, команди та результати",
  "front.openTournament": "Відкрити турнір",
  "front.lastOpened": "Останній відкритий",
  "front.now": "Зараз",
  "front.upcoming": "Попереду",
  "front.past": "Минулі",
  "front.archived": "Завершено",
  "front.drafts": "Чернетки",
  "front.draft": "Чернетка",
  "front.registration": "Реєстрація відкрита",
  "front.empty": "Турнірів ще немає.",
  "front.loadFailed": "Не вдалося завантажити список турнірів. Перевірте зв'язок.",
  "front.stat.teams": {
    one: "{count} команда",
    few: "{count} команди",
    many: "{count} команд",
    other: "{count} команди",
  },
  "front.stat.players": {
    one: "{count} гравець",
    few: "{count} гравці",
    many: "{count} гравців",
    other: "{count} гравця",
  },
  "front.stat.divisions": {
    one: "{count} дивізіон",
    few: "{count} дивізіони",
    many: "{count} дивізіонів",
    other: "{count} дивізіону",
  },
  "front.stat.games": {
    one: "{count} гра",
    few: "{count} гри",
    many: "{count} ігор",
    other: "{count} гри",
  },
  "front.stat.played": "зіграно {played} з {count}",
  "tournament.notFound": "Такого турніру немає.",
  "tournament.notFoundHint": "Перевірте посилання або відкрийте список турнірів.",
  "page.notFound": "Такої сторінки немає.",
  "tournament.loadFailed": "Не вдалося завантажити турнір. Перевірте зв'язок.",
  "tournament.openList": "Усі турніри",
  "board.docTitle": "Живий рахунок · karrtopelka",
  "board.live": "НАЖИВО",
  "board.offline": "ОФЛАЙН",
  "board.final": "ФІНАЛ",
  "board.registration": "РЕЄСТРАЦІЯ",
  // The one load-failed sentence for every list on the platform (clubs, seats,
  // requests, the board): «табло» used to be in it and read wrong under a
  // club's member list (2026-09-16). The key keeps its name.
  "board.loadFailed": "Не вдалося завантажити. Перевірте зв'язок.",
  "board.view.info": "Інфо",
  "board.info.whenWhere": "Дати",
  "board.team.location": "Локація",
  "board.info.ends": "Завершення",
  "board.info.placePending": "Місце ще не оголошено.",
  "board.info.map": "Знайти на карті",
  "board.info.deadlinePending": "Дату закриття ще не оголошено.",
  "board.info.registerHint":
    "Капітан або менеджер реєструє команду зі сторінки свого клубу. Відкрийте свій обліковий запис і виберіть клуб.",
  "board.info.reviewed": "Заявку має схвалити організатор.",
  "board.info.instant": "Команда потрапляє до списку учасників одразу після реєстрації.",
  "board.info.myClubs": "Мої клуби",
  "board.info.participation": "Дивізіони та учасники",
  "board.info.pools": "Групи: {names}",
  "board.info.singleDivision": "Один спільний дивізіон.",
  "board.info.divisionsPending": "Дивізіони ще не оголошено.",
  "board.info.viewTeams": "Переглянути команди та склади",
  "board.info.scheduleFields": "Розклад і поля",
  "board.info.schedulePending": "Розклад ще не опубліковано.",
  "board.info.stream": "Трансляція",
  "board.info.spiritEnabled": "На турнірі збирають оцінки Духу гри.",
  "board.info.spiritDisabled": "Оцінювання Духу гри вимкнено.",
  "board.info.spiritDeadline": "Орієнтовний термін подання оцінок Духу гри: {when}.",
  "board.info.format": "Формат ігор",
  "board.info.formatHint":
    "Поточні налаштування турніру. Для окремих ігор організатор може змінити формат.",
  "board.info.formatProvisional":
    "Попередні налаштування: тривалість ігор ще не підтверджено організатором. Остаточні умови дивіться в регламенті.",
  "board.info.poolGame": "Гра в групі",
  "board.info.bracketGame": "Плей-оф",
  "board.info.finalGame": "Фінал",
  "board.info.target": "Гра до",
  "board.info.noTarget": "Без цільового рахунку",
  "board.info.timeouts": "Тайм-аути за половину",
  "board.info.softCap": "Софт-кап",
  "board.info.hardCap": "Хард-кап",
  "board.info.breaks":
    "Перерва між іграми на полі: {turnaround} хв. Мінімальний відпочинок команди: {rest} хв.",
  "board.info.minutes": {
    one: "{count} хв",
    few: "{count} хв",
    many: "{count} хв",
    other: "{count} хв",
  },
  "board.info.viewSchedule": {
    one: "Переглянути розклад · {count} гра",
    few: "Переглянути розклад · {count} гри",
    many: "Переглянути розклад · {count} ігор",
    other: "Переглянути розклад · {count} гри",
  },
  "board.view.live": "Наживо",
  "board.view.tables": "Таблиці",
  "board.view.teams": "Команди",
  "directory.eyebrow": "КЛУБИ",
  "directory.title": "Клуби",
  "directory.search": "Пошук за назвою або містом",
  "directory.empty": "Такого клубу немає.",
  "directory.profileEyebrow": "КЛУБ",
  "directory.eventsHint": "Оберіть команду, щоб побачити склад і результати.",
  "directory.viewTeam": "Команда та склад",
  "directory.clubRoster": "Гравці клубу",
  "directory.rosterHint": "Склад клубу; на кожен турнір - окрема заявка.",
  "directory.tournaments": "Турніри",
  "directory.podiums": "Подіуми",
  "directory.players": "Гравці",
  "directory.city": "Місто",
  "directory.noTournaments": "Ще без турнірів.",
  "directory.finished": "{place} місце",
  "directory.poolRank": "{place} у {pool}",
  "directory.inProgress": "Триває",
  "directory.upcoming": "Попереду",
  "directory.tournamentsCount": {
    one: "{count} турнір",
    few: "{count} турніри",
    many: "{count} турнірів",
    other: "{count} турніру",
  },
  "board.view.next": "Розклад",
  "board.view.results": "Результати",
  "board.view.leaders": "Лідери",
  "board.view.awards": "Нагороди",
  "board.allTournaments": "Усі турніри",
  "board.spiritFrom": "Дух {n} від {team}",
  "board.spiritFromHint": "Оцінка духу гри, яку ця команда отримала від {team}",

  "board.rulesLink": "Правила гри",
  "board.regulationsLink": "Регламент турніру",
  "regs.eyebrow": "ТУРНІР",
  "regs.pageTitle": "Регламент",
  "regs.docTitle": "Регламент · karrtopelka",
  "regs.none": "Регламент ще не завантажили.",
  "regs.fileOnly": "Цей регламент завантажено як PDF - відкрийте файл нижче.",
  "regs.openFile": "Відкрити файл",
  "rules.eyebrow": "ПРАВИЛА",
  "rules.title": "Правила алтимату",
  "rules.docTitle": "Правила · karrtopelka",
  "rules.intro":
    "Офіційні правила WFDF 2025-2028 українською, з коментарями досвідченого гравця - прямо тут, розділ за розділом.",
  "rules.contents": "Зміст",
  "rules.credit": "Переклад - Українська федерація флаїнг-диску, подача і коментарі -",
  "board.watchLive": "Дивитись: {field}",
  "board.onFields": "НА ПОЛЯХ",
  "board.noGame": "Зараз гри немає.",
  "board.live.watch": "Дивитись трансляцію",
  "board.live.timeout": "Тайм-аут · {team}",
  "board.live.timeouts": "Тайм-аути: {left} з {total}",
  "board.live.pitches": "Поля",
  "board.live.badge": "Наживо",
  "board.live.eventOverview": "Про турнір",
  "board.live.nextGame": "Наступна гра",
  "board.live.untilStart": "До початку",
  "board.live.startingNow": "Починається",
  "board.live.laterHere": "ДАЛІ НА ЦЬОМУ ПОЛІ",
  "board.live.earlierHere": "РАНІШЕ НА ЦЬОМУ ПОЛІ",
  "board.live.pitchDone": "На цьому полі ігор більше немає.",
  "board.live.allPlayed": "Усе зіграно",
  "board.live.tab.points": "Поінти",
  "board.live.tab.leaders": "Лідери",
  "board.live.breakKey": "брейк",
  "board.offense": "АТАКА",
  "board.winProbability": "Шанси на перемогу",
  "board.runOfPlay": "Хід гри",
  "board.onARun": "{team} виграли {n} поспіль",
  "board.placeInPool": "Місце в групі",
  "board.placeInDivision": "Місце в дивізіоні",
  "board.leaders": "Лідери за поінтами",
  "board.lastPoints": "Останні поінти",
  "board.uncredited": "Без автора",
  "board.break": "БРЕЙК",
  "board.lastPoint": "ОСТАННІЙ ПОІНТ",
  "board.longestPoint": "НАЙДОВШИЙ ПОІНТ",
  "board.gameTo": "ГРА ДО {n}",
  "board.winnerTops": "Переможець очолить {group}",
  "board.breaks": "БРЕЙКИ",
  // An en dash, the way Ukrainian sports listings write a fixture. «проти»
  // pushed a two-name row past the truncation point at 375px, and rule 2 of the
  // dash cleanup keeps en dashes exactly for this.
  "board.vs": "–",
  "board.vsUpper": "ПРОТИ",
  "board.next": "ДАЛІ",
  "board.menu": "Меню",

  // Slashed, not «{played} з {total}»: the note is uppercased by CSS and a
  // capital «З» between two numerals reads as a 3.
  "board.poolProgress": "зіграно {played}/{total}",
  "board.bracketTitle": "{division}: СІТКА",
  "board.afterPool": "після групового етапу",
  "board.loadingBracket": "Завантаження сітки…",
  "board.seedsPending": {
    one: "Посів визначиться після групового етапу ({division}). Лишилася {count} гра.",
    few: "Посів визначиться після групового етапу ({division}). Лишилося {count} гри.",
    many: "Посів визначиться після групового етапу ({division}). Лишилося {count} ігор.",
    other: "Посів визначиться після групового етапу ({division}). Лишилося {count} ігор.",
  },
  "board.calendar": "Додати розклад у свій календар",
  "board.results": "РЕЗУЛЬТАТИ",
  "board.finals": "ФІНАЛИ",
  "board.noResults": "Поки що жодної зіграної гри.",
  "board.leadersTitle": "ЛІДЕРИ ТУРНІРУ",
  "board.award.champion": "Переможці",
  "board.award.stats": "Записана статистика: {name}",
  "board.award.goals": "Голи",
  "board.award.assists": "Асисти",
  "board.award.spiritAverage": "Середня оцінка духу гри",
  "board.award.spirit": "Дух гри",
  "board.award.sharedSpirit": "Дух гри · Спільна перемога",
  "board.awardsTitle": "НАГОРОДИ",
  "board.spiritTitle": "ДУХ ГРИ",

  "board.upNext": "НАСТУПНІ ІГРИ",
  "board.scheduleSoon": "Розклад скоро з'явиться.",
  "board.allPlayed": "На сьогодні всі ігри зіграно.",
  "board.laterToday": "СЬОГОДНІ ПІЗНІШЕ",
  "board.today": "СЬОГОДНІ",
  "board.next.list": "Список",
  "board.next.byField": "За полями",
  "board.roster": "Склад",
  "board.banner.rosterEntries": "Гравці у заявках",
  "board.rosterEmpty": "Склад не внесено.",
  "board.teamGames": "Ігри",
  "board.resW": "В",
  "board.resL": "П",
  "board.resD": "Н",
  "board.resultTitle": "Результат",
  "board.noPoints": "Похвилинного запису для цієї гри немає.",
  "board.resultCard": "Картка результату",
  "board.assistBy": "асист {name}",
  "board.breakPoint": "Брейк",
  "board.gamesCount": {
    one: "{count} гра",
    few: "{count} гри",
    many: "{count} ігор",
    other: "{count} ігор",
  },

  // Table headers are written in sentence case; `table.tsx` uppercases them.
  "board.col.team": "Команда",
  "board.col.played": "І",
  "board.col.winLoss": "В-П",
  "board.col.winDrawLoss": "В-Н-П",
  "board.col.diff": "+/−",
  "board.col.form": "Останні 5",
  "board.team.back": "Табло",
  "board.team.missing": "Такої команди тут немає.",
  "board.team.viewClub": "Переглянути клуб",
  "board.team.yourTeam": "Ваша команда",
  "board.team.yourTeams": "Ваші команди",
  "board.team.yourTeamLink": "{short}, ваша команда: {team}",
  "board.team.wins": "Перемоги",
  "board.team.losses": "Поразки",
  "board.team.lossesDraws": "Поразки · нічиї",
  "board.team.captain": "Капітан",
  "board.team.spirit": "Спіріт",
  "board.team.also": "Інші турніри клубу",
  "board.team.schedulePending": "Розклад команди ще не опубліковано.",
  "board.teamsCount": {
    one: "{count} команда",
    few: "{count} команди",
    many: "{count} команд",
    other: "{count} команди",
  },
  "board.tournamentsCount": {
    one: "{count} турнір",
    few: "{count} турніри",
    many: "{count} турнірів",
    other: "{count} турніру",
  },
  "board.game.pointByPoint": "Поінт за поінтом",
  "board.game.notPlayed": "Ще не зіграно.",
  "board.story.title": "Історія гри",
  "board.story.scorer": "Гол",
  "board.story.assist": "Асист",
  "board.story.notRecorded": "Не записано",
  "board.story.noCredits": "Авторів гола й асисту не записано",
  "board.story.start": "Початок",
  "board.story.score": "Перебіг рахунку",
  "board.story.winProb": "Ймовірність перемоги",
  "board.story.winProbHint":
    "Перегони до {n} з того, як часто приймаюча сторона тримала холд; посів і результати не враховано.",
  "board.story.longestRun": "Найдовша серія",
  "board.story.largestLead": "Найбільша перевага",
  "board.story.leadChanges": "Змін лідера",
  "board.story.half": "На галфтаймі",
  "board.story.duration": "Від першого до останнього поінту",
  "board.story.holds": "Холди",
  "board.story.pointLengths": "Тривалість поінтів",
  "board.story.scorers": "Бомбардири",
  "board.story.hookups": "Зв'язки",
  "board.story.pointN": "Поінт {n}",
  "board.story.halfMark": "Галфтайм",
  "board.story.whatIsThis": "Що це означає",
  "board.story.hint.breaks":
    "Брейк - поінт, який виграла команда, що пулила (захист). Рахуємо для кожної команди.",
  "board.story.hint.longestRun": "Найбільше поінтів поспіль однієї команди.",
  "board.story.hint.largestLead": "Найбільший відрив у рахунку за всю гру і хто його мав.",
  "board.story.hint.leadChanges": "Скільки разів лідер змінювався. Нічия не рахується.",
  "board.story.hint.half": "Рахунок на момент галфтайму.",
  "board.story.hint.longestPoint":
    "Поінт, який тривав найдовше - від попереднього рахунку до свого.",
  "board.story.hint.duration":
    "Від першого поінту до останнього - частина гри, яку можна виміряти за записом.",
  "board.story.hint.holds":
    "Холд - поінт, який виграла команда, що приймала пул (напад). Тут {holds} з {n} поінтів.",
  "board.story.hint.pointLengths":
    "Один стовпчик - один поінт: висота - скільки він тривав, колір - хто забив. Наведіть або торкніться стовпчика, щоб побачити деталі.",
  "board.story.hint.score":
    "Рахунок після кожного поінту; кружечок позначає гол. Наведіть, торкніться або скористайтеся стрілками, щоб переглянути рахунок. Заливка - перевага; вертикальний пунктир - орієнтовний галфтайм.",
  "board.story.hint.runOfPlay":
    "Один блок - один поінт, кольором команди, що забила. Підкреслення - брейк.",
  "board.col.player": "Гравець",
  "board.col.goals": "Г",
  "board.col.assists": "А",
  "board.col.breaks": "БР",
  "board.col.teamGames": "І",
  "board.col.perGame": "За гру",
  "board.perGameNote":
    "Рейтинг - за середнім на гру: у команд різна кількість ігор, і сума була б нечесною до тих, хто зіграв менше.",
  "board.col.average": "Сер.",
  "board.col.game": "Гра",
  "board.col.scoresGiven": "Виставлені оцінки",

  "board.sort.goals": "ГОЛИ",
  "board.sort.assists": "АСИСТИ",
  "board.sort.total": "Г + А",
  "board.sort.breaks": "БРЕЙКИ",
  "board.leadersCaveat":
    "Лише голи й асисти: блоки, втрати та гра в захисті на цьому турнірі не фіксуються, і немає даних про те, хто виходив на поле. Тож ці таблиці показують результативність і більше нічого.",
  "board.coverage": "{pct} ПОІНТІВ МАЮТЬ АВТОРА",
  "board.topOf": "Показано {shown} з {total} гравців із зарахованим голом або асистом.",
  "board.brkNote":
    "БР - це голи й асисти, здобуті в розіграшах, які команда починала в захисті. І - це кількість ігор, які провела КОМАНДА гравця: склади не фіксуються, тож це не кількість ігор, у яких він виходив на поле.",
  "board.rankedAfterGames": {
    one: "Ранжування - від {count} зіграної командою гри.",
    few: "Ранжування - від {count} зіграних командою ігор.",
    many: "Ранжування - від {count} зіграних командою ігор.",
    other: "Ранжування - від {count} зіграних командою ігор.",
  },
  "board.rankedAfterScores": {
    one: "Ранжування - від {count} отриманої оцінки.",
    few: "Ранжування - від {count} отриманих оцінок.",
    many: "Ранжування - від {count} отриманих оцінок.",
    other: "Ранжування - від {count} отриманих оцінок.",
  },
  "board.allDivisions": "Усі дивізіони",

  // ---------- bracket canvas (shared by the board and the admin editor) ----------
  "bracket.zoomOut": "Зменшити",
  "bracket.zoomIn": "Збільшити",
  "bracket.team": "Команда",
  "bracket.allTeams": "Усі команди",
  "bracket.fit": "Вмістити",
  "bracket.close": "Закрити",
  "bracket.fullScreen": "На весь екран",
  "bracket.hint":
    "Торкніться назви команди, щоб побачити її шлях. Тягніть, щоб рухати; зводьте пальці або крутіть, щоб масштабувати.",
  "bracket.tapAgain": "Торкніться назви ще раз, щоб зняти.",
  "bracket.pathBoth": {
    one: "{count} гра визначена, ще {possible} можливих.",
    few: "{count} гри визначені, ще {possible} можливих.",
    many: "{count} ігор визначено, ще {possible} можливих.",
    other: "{count} ігор визначено, ще {possible} можливих.",
  },
  "bracket.pathOnly": {
    one: "{count} гра.",
    few: "{count} гри.",
    many: "{count} ігор.",
    other: "{count} ігор.",
  },
  "bracket.thatGame": "ця гра",
  "bracket.empty": "Поки що нічого немає.",
  "bracket.clearSide": "Очистити цю сторону",
  "bracket.dragWinner": "Перетягніть переможця в іншу гру",
  "bracket.dragLoser": "Перетягніть переможеного в іншу гру",
  "bracket.legendWin": "переможець іде в",
  "bracket.legendLose": "переможений іде в",
  "bracket.legendHelp": "Перетягніть W або L на сторону гри, щоб з'єднати; × очищає сторону.",
  "bracket.loop": "Так сітка зациклиться.",
  "bracket.selfMatch": "Команда не може грати сама із собою: {game} вже отримує цей результат.",
  "bracket.moved": "Переміщено: {outcome} гри «{from}» більше не йде у {names}.",
  "bracket.outcome.winner": "переможець",
  "bracket.outcome.loser": "переможений",

  // ---------- period (shared/types.ts PERIOD_LABEL stays English for OBS) ----------
  // Short forms for the board, where the strip is narrow. "final" is the END OF
  // A GAME, never the final GAME — «Фінал» here would be a real mistranslation.
  "period.short.pregame": "ПЕРЕД ГРОЮ",
  "period.short.h1": "1 ПОЛОВИНА",
  "period.short.half": "ГАЛФТАЙМ",
  "period.short.h2": "2 ПОЛОВИНА",
  "period.short.final": "ЗАВЕРШЕНО",
  // Plain words for the scorekeeper, which never uses jargon — and SHORT, because
  // they sit in a three-across grid on a 375px phone where `ChoiceGroup`
  // truncates rather than wraps. «Перший тайм» ellipsed to «Перший та…».
  "period.long.pregame": "Перед грою",
  "period.long.h1": "1-й тайм",
  "period.long.half": "Галфтайм",
  "period.long.h2": "2-й тайм",
  "period.long.final": "Завершено",

  // ---------- slots (shared/types.ts slotLabel stays English for OBS) ----------
  "slot.tbd": "Не визначено",
  "slot.winner": "Переможець {game}",
  "slot.loser": "Програвший в {game}",
  "slot.game": "гра",
  "slot.unknownDivision": "?",

  // ---------- names with a fallback ----------
  "name.field": "Поле {id}",
  "name.noDivision": "Без дивізіону",
  // «група», never «пул»: that word already means the PULL.
  "name.noPool": "Без групи",

  // ---------- generated game notes (shared/generate.ts canonical strings) ----------
  "note.final": "Фінал",
  "note.semifinal": "Півфінал {n}",
  "note.quarterfinal": "Чвертьфінал {n}",
  "note.roundOf": "1/{half} фіналу - {n}",
  "note.thirdPlace": "Матч за 3-тє місце",
  "note.grandFinal": "Гранд-фінал",
  "note.grandFinalIfNeeded": "Гранд-фінал (за потреби)",
  "note.losersFinal": "Фінал нижньої сітки",
  "note.losersSemifinal": "Півфінал нижньої сітки",
  "note.losersRound": "Нижня сітка, раунд {n}",
  "note.losersRoundIndexed": "Нижня сітка, раунд {n} - {i}",
  "note.winnersBracket": "Верхня сітка: {name}",
  "note.poolRound": "{pool}, тур {n}",
  "note.pool": "Група", // default note when a pool has no name
  // «{place}» is already the ordinal («5-те»): Ukrainian endings do not follow
  // the last digit alone, so `src/i18n/format.ts` builds the word, not this.
  "note.placement": "Матч за {place} місце",
  "note.placementRound": "{name} за {place} місце",
  "note.swissRound": "Швейцарка, тур {n}",

  // ---------- spirit categories (WFDF sheet wording, Ukrainian) ----------
  "spirit.category.rules": "Знання та використання правил",
  "spirit.category.fouls": "Фоли та фізичний контакт",
  "spirit.category.attitude": "Позитивне ставлення й самоконтроль",
  "spirit.category.fairness": "Справедливість",
  "spirit.category.communication": "Комунікація",
  "spirit.hint.rules": "Чи знали вони правила, дотримувалися їх і вкладалися у відведений час?",
  "spirit.hint.fouls":
    "Чи грали вони безпечно: без небезпечних дій і без контакту, більшого за випадковий?",
  "spirit.hint.attitude": "Чи були вони ввічливі, стримані й спокійні, коли ставало напружено?",
  "spirit.hint.fairness":
    "Чи чесно вони вирішували спірні моменти й забирали назад помилкові виклики?",
  "spirit.hint.communication":
    "Чи пояснювали вони зрозуміло, чи слухали і чи користувалися жестами?",
  "spirit.value.0": "Погано",
  "spirit.value.1": "Не дуже",
  "spirit.value.2": "Нормально (добре)",
  "spirit.value.3": "Дуже добре",
  "spirit.value.4": "Відмінно",
  "spirit.notScored": "Ще не оцінено",

  // ---------- stat columns (shared/player-stats.ts STAT_LABEL) ----------
  "stat.goals": "Голи",
  "stat.assists": "Асисти",
  "stat.total": "Голи + асисти",
  "stat.breaks": "Участь у брейках",
  "board.live.goal": "Гол",
  "board.live.goalFor": "Гол команди {team}",
  "board.live.assistBy": "Асист: {player}",
  "board.live.finalMinutes": "Останні хвилини",
  "board.live.gamePoint": "ГЕЙМ-ПОІНТ",
  "board.live.universePoint": "ВИРІШАЛЬНИЙ ПОІНТ",
  "board.live.winner": "Переможець",
  "fan.support.title": "За кого вболіваєш?",
  "fan.support.count": "Підтримують: {count}",
  "fan.support.first": "Підтримай першим",
  "fan.support.team": "Підтримати {team}",
  "fan.support.saved": "Ви вболіваєте за {team}",
} as const;
